import store from '../store/index';

const REDIRECT = 'redirect-url';
/**
* Saves the logged user's details
* @param {Object} userData
*/
export function setSessionUser(userData) {
	// commit user to state
	store.commit('setLoggedUser', userData);
	store.commit('setUserObject', userData);
}

/**
* Resets the logged-in user
*/
export function clearSession() {
	setSessionUser({});
}

/**
* Retrieves the logged in user
* @return {Object} user - Stored user
*/
export function getSessionUser() {
	// get user from state
	return store.getters.getLoggedUser;
}

/**
* Stores the route to redirect to after succesful login
* @param {String} path - the path to redirect
*/
export function setRedirectURL(path) {
	localStorage.setItem(REDIRECT, path);
}

/**
* Checks if a user is logged in
* //returns true if a user is logged in
* @returns {Boolean} returns true or false
*/
export function isLoggedIn() {
	return store.getters.isLoggedIn;
}

/**
* Gets the stored redirect path and resets it to the homepage
* @returns {String} path - the saved redirect path
*/
export function getRedirectUrl() {
	const redirectUrl = localStorage.getItem(REDIRECT) || '/';
	setRedirectURL('/');
	return redirectUrl;
}

/**
* Auth guard allows authenticated users only.
* @param to - next route
* @param from - previous route
* @param next - callback to transfer control to the next middleware
*/
export function requireAuth(to, from, next) {
	if (isLoggedIn()) {
		next();
	} else {
		setRedirectURL('/');
		next({ name: 'login' });
	}
}

/**
* Auth guard that allows non-auhtenticated users only.
* @param to - the next route
* @param from - the previous route
* @param next - callback to transfer control to the next middleware
*/

export function noAuthOnly(to, from, next) {
	if (isLoggedIn()) {
		next({ path: '/' });
	} else {
		next();
	}
}
